import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import LoadingButton from '../../../../Components/LoadingButton';
import { UsersActions } from '../../../../Redux/modules/users/actions';
import styles from './ResetPasswordModal.module.less';
import AnalyticsHandler from '../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const resetPasswordModal = (props) => {
  const { id } = props.userData;

  const sendResetLink = () => {
    props.onResetPassword(id);
  };

  return (
    <div className={styles.modalContainer}>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.header} id="modal-title">
        {gettext('Reset password')}
      </div>
      <span className={styles.text}>{gettext('Send a password reset link by email to the user.')}</span>
      <div className={styles.buttonContainer}>
        <div className={styles.buttonUpdate}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.SEND_RESET_PASSWORD_LINK}
            eventData={{ manipulatedUser: props.userData.id, manipulatedUserEmail: props.userData.email }}
          >
            <LoadingButton
              buttonClass="primary-blue"
              type="submit"
              text={gettext('Send Link')}
              width="39%"
              onClick={sendResetLink}
              id="submit-button"
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonCancel}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            width="39%"
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

resetPasswordModal.propTypes = {
  userData: PropTypes.object,
  close: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
  onResetPassword: PropTypes.func,
};

const mapDispatchToProps = {
  onResetPassword: UsersActions.resetPassword,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
};

export default connect(null, mapDispatchToProps)(resetPasswordModal);
